/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-10 19:14:41
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-06-22 15:52:18
 * @FilePath: \vue-hepha-order\src\views\stock\queryConfig\QueryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const ReturnFactoryQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单名称
            key:'order_name',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.orderName',
        },
        {
            // name:'order.orderSource', // mes返修单号
            key:'swap_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'stock.returnFactoryNumber',
        },
        {
            // name:'order.deliverStatus', // 返修状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'stock.returnFactoryStatus',
            options:[
                {
                    value:1,
                    label:'stock.returningFactory'
                },
                {
                    value:4,
                    label:'stock.outScanned'
                },
                {
                    value:2,
                    label:'stock.returnFactorySuccessful'
                },
                // {
                //     value:3,
                //     label:'stock.cancelReturnFactory'
                // },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        {
            // name:'order.erpNo', // SO
            key:'erp_no',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerType', // 仓库
            key:'swap_inventory',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.warehouse',
            options:[]
        },
        {
            // name:'order.customerType', // 客户
            key:'customer_id',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            // name:'order.customerType', // 备注
            key:'remark',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
        {
            name:'', // 预计退货时间
            key:'back_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planReturnStartDate',
            placeholder2:'stock.planReturnEndDate',
        },
        {
            name:'', // 实际退货时间
            key:'back_real_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realReturnStartDate',
            placeholder2:'stock.realReturnEndDate',
        },
        {
            name:'', // 返修计划发出时间
            key:'swap_timestamp_plan',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planShipStartDate',
            placeholder2:'stock.planShipEndDate',
        },
        {
            name:'', // 返修实际发出时间
            key:'swap_timestamp_real',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realShipStartDate',
            placeholder2:'stock.realShipEndDate',
        },
    ]
}

const ReturnFactoryEditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'280px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 物流公司
            key:'swap_courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 物流单号
            key:'swap_courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 物流链接
            key:'swap_courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierStatus', // 物流状态
            key:'swap_courier_status',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    label:'order.shiped',
                    value:3,
                },
            ]
        },
        {
            name:'stock.cargoFreight', // 运费
            key:'cargo_freight',
            type:'input',
            width:'260px',
            allowClear:true,
            prefix:true,
        },
    ]
}

const ReturnFactoryEditForm2 = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'280px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 退回物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 退回物流单号
            key:'courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 退回物流链接
            key:'courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
    ]
}


ReturnFactoryQueryForm.formField.forEach(item=>{
    ReturnFactoryQueryForm.formData[item.key] = ''
})

ReturnFactoryEditForm.formField.forEach(item=>{
    ReturnFactoryEditForm.formData[item.key] = ''
})

ReturnFactoryEditForm2.formField.forEach(item=>{
    ReturnFactoryEditForm2.formData[item.key] = ''
})

export {
    ReturnFactoryQueryForm,
    ReturnFactoryEditForm,
    ReturnFactoryEditForm2,
}